/**
 * Rebuy Side Cart Integration
 * 
 * This script handles opening Rebuy Side Cart when products are added to cart
 * on pages without a standard Shopify cart drawer.
 * 
 * It prevents redirects to the cart page and opens Rebuy cart instead.
 */

(function() {
  'use strict';

  let rebuyCartOpened = false;

  // Check if Rebuy is available
  function isRebuyAvailable() {
    return typeof Rebuy !== 'undefined' && Rebuy.SmartCart;
  }

  // Check if there's a standard cart drawer
  function hasCartDrawer() {
    return document.querySelector('cart-drawer, cart-notification') !== null;
  }

  // Open Rebuy cart
  function openRebuyCart() {
    if (isRebuyAvailable() && !rebuyCartOpened) {
      try {
        rebuyCartOpened = true;
        Rebuy.SmartCart.show();
        // Reset flag after a delay
        setTimeout(function() {
          rebuyCartOpened = false;
        }, 1000);
        return true;
      } catch (error) {
        console.error('Error opening Rebuy cart:', error);
        rebuyCartOpened = false;
        return false;
      }
    }
    return false;
  }

  // Override routes.cart_url to prevent redirects
  function overrideCartRoute() {
    if (typeof window.routes === 'undefined') {
      window.routes = {};
    }

    // Store original cart_url if it exists
    const originalCartUrl = window.routes.cart_url || '/cart';

    // Override the getter for cart_url
    Object.defineProperty(window.routes, 'cart_url', {
      get: function() {
        // If no cart drawer and Rebuy is available, return a no-op value
        if (!hasCartDrawer() && isRebuyAvailable()) {
          return '#rebuy-cart';
        }
        return originalCartUrl;
      },
      configurable: true
    });
  }

  // Intercept navigation attempts
  function interceptNavigation() {
    // Intercept clicks on links that would go to cart
    document.addEventListener('click', function(e) {
      const target = e.target.closest('a');
      if (target && target.href) {
        const href = target.href;
        if ((href.includes('/cart') || href === window.location.origin + '/cart') && 
            !hasCartDrawer() && 
            isRebuyAvailable()) {
          e.preventDefault();
          openRebuyCart();
        }
      }
    }, true);
  }

  // Monitor for location changes
  function monitorLocationChanges() {
    let currentUrl = window.location.href;

    // Use MutationObserver as a fallback to detect navigation
    const observer = new MutationObserver(function() {
      const newUrl = window.location.href;
      if (newUrl !== currentUrl) {
        currentUrl = newUrl;
        // If we navigated to cart page and Rebuy is available, open cart
        if (newUrl.includes('/cart') && !hasCartDrawer() && isRebuyAvailable()) {
          // Go back and open Rebuy cart
          window.history.back();
          setTimeout(openRebuyCart, 100);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  // Patch window.location.href setter
  function patchLocationHref() {
    const location = window.location;
    const originalHref = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(location), 'href');

    if (originalHref && originalHref.set) {
      Object.defineProperty(location, 'href', {
        get: originalHref.get,
        set: function(url) {
          // Check if it's a redirect to cart page
          if (typeof url === 'string' && (url.includes('/cart') || url === '/cart')) {
            if (!hasCartDrawer() && isRebuyAvailable()) {
              // Open Rebuy cart instead
              if (openRebuyCart()) {
                return; // Prevent redirect
              }
            }
          }
          // Allow other redirects
          originalHref.set.call(location, url);
        },
        configurable: true
      });
    }
  }

  // Initialize
  function init() {
    // Only set up if there's no cart drawer
    if (hasCartDrawer()) {
      return; // Don't interfere with standard cart drawer
    }

    // Set up overrides immediately
    overrideCartRoute();
    interceptNavigation();

    // Wait for Rebuy to load (it might load asynchronously)
    function setupWhenRebuyReady() {
      if (isRebuyAvailable()) {
        patchLocationHref();
        monitorLocationChanges();
      } else {
        // Check again after a delay
        setTimeout(setupWhenRebuyReady, 500);
      }
    }

    setupWhenRebuyReady();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
